import { render, staticRenderFns } from "./AppLayoutEmbedded.vue?vue&type=template&id=1dcb9390&"
import script from "./AppLayoutEmbedded.vue?vue&type=script&lang=js&"
export * from "./AppLayoutEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutEmbedded.vue?vue&type=style&index=0&id=1dcb9390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports